import { render } from "./Css.vue?vue&type=template&id=5a8d4d8b&scoped=true"
import script from "./Css.vue?vue&type=script&lang=js"
export * from "./Css.vue?vue&type=script&lang=js"

import "./Css.vue?vue&type=style&index=0&id=5a8d4d8b&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8d4d8b"]])

export default __exports__